import { useLocation } from "react-router-dom";

export const ID_TAB_MINI_GAME = {
  home: "home",
  collectPiece: "collect-piece",
  pieceCollection: "piece-collection",
  prizeCollection: "prize-collection",
  takePrize: "take-prize",
  inviteUser: "invite-user",
  requestPiece: "request-piece",
  givePiece: "give-piece",
  buyMoreCoin: "buy-more-coin",
};

export const TYPE_GIVE_MINIGAME = {
  request: "REQUEST",
  give: "GIVE",
};

export const TYPE_GIVE_PIECE = "GIVE_PIECE";
export const TYPE_REQUEST_PIECE = "REQUEST_PIECE";
export const TYPE_GIVE_PIECE_SUCCESS = "GIVE_PIECE_SUCCESS";
export const TYPE_DETAIL_PUZZLE_PIECE = "DETAIL_PUZZLE_PIECE";

export const ID_TAB_TAKE_PRIZE = {
  takePrize: 1,
  pieceCollection: 2,
};
export const ID_INVITE_USER = "invite-user";

export const HIDDEN_POPUP_RANKING_MINIGAME = "HIDDEN_POPUP_RANKING_MINIGAME";

export const INVITE_MARQUEE_START_DATE = null;
export const INVITE_MARQUEE_END_DATE = null;

export const ID_GIFT_PLAY_LOTO = {
  good_luck: 1,
  bid_free: 2,
  puzzle_piece: 3,
  add_spin: 4,
};

export const ID_GIFT_PLAY_LOTO_MINIGAME = {
  good_luck: "GOOD_LUCK",
  add_spin: "ADD_SPIN",
  bid_free: "BID_FREE",
  puzzle_piece: "PUZZLE_PIECE",
  no_coins: "NO_COINS",
  coin_super: "COIN_SUPER",
};

export const POPUP_VARIANT_EVENT_THINGYAN_2025 = {
  rule: 3,
};

export const ID_HIDDEN_POPUP_INTRO_GIFT = "MINI_GAME_HIDDEN_POPUP_INTRO_GIFT";

export const currentDate = Date.now();

// Theme hooks for cloned module. In this repo we default to "false".
// If you need real theme toggles, we can wire them to event id in route params.
export function useThadingyutTheme() {
  useLocation(); // keep hook stable for callers
  return false;
}

export function useNewYear2025Theme() {
  useLocation();
  return false;
}

